import React from 'react';
import {t} from '@lingui/core/macro';

import NoIncident from 'shared/ui/icons/NoIncident';

import Plug from '../Plug/Plug';
import PlugCreateButton from '../PlugCreateButton/PlugCreateButton';

interface PlugNoIncidentsProps {
    onCreate?: () => void;
    buttonText?: string;
    size?: 'md' | 'sm';
}

const PlugNoIncidents: React.FC<PlugNoIncidentsProps> = ({onCreate, buttonText, size}) => {
    return (
        <Plug
            size={size}
            icon={<NoIncident/>}
            title={t`Всё в порядке`}
            text={t`Инциденты появятся здесь при возникновении проблем.`}
            action={
                onCreate && buttonText && <PlugCreateButton onClick={onCreate}>
                    {buttonText}
                </PlugCreateButton>
            }
        />
    );
};

export default PlugNoIncidents;
